module.exports = __webpack_public_path__ + "img/NLG.ba79caa6.svg";